<template>
  <v-container grid-list-md fluid class="pt-0 pb-0">
    <v-card class="pa-2 card-r grey lighten-4">
      <v-toolbar class="primary mb-2 darken-2 card-r shadow-1 pl-3 text-white">
        <v-btn icon to="/adminprofile">
          <v-icon color="white">keyboard_arrow_left</v-icon>
        </v-btn>
        <!--<router-link to="/"><v-icon class="text-white left pr-3">keyboard_arrow_left</v-icon></router-link>-->
        <div class="text-xs-left f-20">Edit Driving School</div>
      </v-toolbar>
                <v-layout wrap>
                  <v-flex xs12 class="text-xs-left">
                    <div class="">School details</div>
                  </v-flex>
                  <v-flex xs12 lg4 class="pl-2">
                    <v-img :src="images.profile_image_preview" class="shadow-1 cercle" height="150" width="150"></v-img>
                    <v-btn color="grey" @click="onPickImage('profile')" class="shadow-1 ma-0 my-2 text-white card-r">Change Profile image</v-btn>
                  </v-flex>

                  <input
                    type="file"
                    style="display:none"
                    ref="imageInput"
                    accept="image/png"
                    @change="OnImagePicked"
                  >

                  <v-flex xs12 lg8 class="pl-2">
                    <v-img size="36px" :src="images.cover_image_preview" class="CoverPhoto card-r"></v-img>
                    <v-btn color="grey" @click="onPickImage('cover')" class="shadow-1 ma-0 my-2 text-white card-r">Change Cover image</v-btn>
                  </v-flex>
                  <v-flex xs12 lg4>
                    <v-text-field
                      required
                      color="#749DBF"
                      type="text"
                      placeholder="CVR Number"
                      class="textFeald"
                      solo
                      label="CVR Number"
                      v-model="club.cvr"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 lg4>
                    <v-text-field
                      required
                      color="#749DBF"
                      type="text"
                      placeholder="School Name"
                      class="textFeald"
                      solo
                      label="School Name"
                      v-model="club.schoolName"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 lg4>
                    <v-text-field
                      required
                      color="#749DBF"
                      class="textFeald"
                      solo
                      prefix="+45"
                      type="number"
                      label="Phone Number"
                      placeholder="Phone Number"
                      :rules="[ v => v.length >= 8 || 'Min 8 characters']"
                      v-model="club.phone"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 lg4 class="mb-3">
                    <v-flex xs12 class="white shadow-1 py-2 my-1">
                      <!--<div slot="label-top" class="active ml-2 text-xs-left w-100 text-primary f-9 pt-2">Address</div>-->
                      <vue-dawa
                        @select="selectItem($event, 'address')"
                        :val="address.oneLineAddress"
                        :showMax="5"
                        placeholder="Address"
                        containerId="amdinAddress_container"
                        fieldId="amdinAddress_id"
                        fieldName="amdinAddress_name"
                        v-model="address"
                      ></vue-dawa>
                  </v-flex>
                  </v-flex>
                  <v-flex xs12 lg4>
                    <v-text-field
                      required
                      color="#749DBF"
                      type="text"
                      placeholder="Email"
                      class="textFeald"
                      solo
                      label="Email"
                      v-model="club.email"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="text-xs-left pt-0 ">
                    <div class="">Admin details</div>
                  </v-flex>
                  <v-flex xs12 lg4>
                    <v-text-field
                      required
                      color="#749DBF"
                      type="text"
                      placeholder="User Name"
                      class="textFeald"
                      solo
                      label="Full Name"
                      v-model="admin.name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 lg4>
                    <v-text-field
                      required
                      color="#749DBF"
                      type="text"
                      placeholder="Email"
                      class="textFeald"
                      solo
                      label="Email"
                      v-model="admin.email"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 lg4>
                    <v-text-field
                      required
                      color="#749DBF"
                      type="text"
                      prefix="+45"
                      placeholder="Phone"
                      class="textFeald"
                      solo
                      label="Phone"
                      v-model="admin.phone"
                    ></v-text-field>
                  </v-flex>


                  <v-flex xs12 lg4 class="textFeald date">
                    <v-dialog
                      ref="dialog"
                      :close-on-content-click="false"
                      v-model="birthday"
                      :return-value.sync="admin.dob"
                      lazy
                      persistent
                      full-width
                      width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="admin.dob"
                        label="Birthday"
                        placeholder="Birthday"
                        solo
                        readonly
                        required
                      ></v-text-field>
                      <v-date-picker v-model="admin.dob" no-title scrollable @input="$refs.dialog.save(admin.dob)">
                        <!-- <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="birthday = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="$refs.dialog.save(date)">OK</v-btn> -->
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>

                  <v-flex xs12 lg4>
                    <v-select
                      color="#749DBF"
                      v-model="admin.gender"
                      :items="gender_"
                      label="Gender"
                      required
                      solo
                      placeholder="Gender"
                    ></v-select>

                  </v-flex>

                  <!-- <v-flex xs12>
                    <v-text-field
                      required
                      color="#749DBF"
                      class="textFeald"
                      solo
                      label="Discription"
                      placeholder="Discription"
                      v-model="discription"
                      multi-line
                    ></v-text-field>
                  </v-flex> -->


                 <!-- <v-flex xs6>
                    <v-text-field
                      required
                      color="#749DBF"
                      class="textFeald"
                      type="number"
                      solo
                      label="Commission Rate"
                      placeholder="Commission Rate"
                      v-model="commission"
                    ></v-text-field>
                  </v-flex>-->

                 <!-- <v-flex xs6>
                    <v-select
                      v-model="cancel_time"
                      :items="cancel_time_"
                      attach

                      chips
                      placeholder="Cancel Time"
                      label="Cancel Time"

                    ></v-select>
                  </v-flex>-->

                  <!-- <v-flex xs6>
                    <v-text-field
                      required
                      color="#749DBF"
                      class="textFeald"
                      solo
                      label="Email"
                      placeholder="Email"
                      v-model="adminemail"
                    ></v-text-field>
                  </v-flex> -->

                </v-layout>
                  <v-flex lg12 xs12 sm12>
                      <v-progress-circular
                          indeterminate
                          v-if=loading
                          color="primary"
                      ></v-progress-circular>
                      <v-alert
                        :value="true"
                        color="success"
                        icon="check_circle"
                        v-if="alert.type=='success'"
                        outline
                      >
                        {{alert.msg}}
                      </v-alert>
                      <v-alert
                        :value="true"
                        color="error"
                        icon="warning"
                        v-if="alert.type=='warning'"
                        outline
                      >
                        {{alert.msg}}
                      </v-alert>

                  </v-flex>
            <v-flex lg12 xs12 sm12 class="pt-0">
              <div class="w-100 text-xs-right">
                <v-btn color="primary darken-2" @click="updateProfile" class="card-r" dark @EditClub="true" >Update</v-btn>
              </div>
            </v-flex>
      </v-card>
      <!-- <notifications group="error" position="top center"/>
     <notifications group="success" position="bottom center"/> -->
    </v-container>
</template>

<script>
  /* eslint-disable */
import VueDawa from "vue-dawa";
import api from "../../../utils/backend-api.js"

  export default {
    components:{
      VueDawa
    },
    props:["id"],
    name: "EditCustomer",
    data: () => ({
      club:{
        cvr:'',
        schoolName:'',
        phone:'',
        email:'',
      },
      admin:{
        name:'',
        email:'',
        dob:'',
        gender:'',
      },
      ClubView:null,
      passwordShow: false,
      coverPhoto: "https://s3.amazonaws.com/stg-drivers-license-assistance.org/images/blog/find-driving-teacher.jpg",
      EditClub: false,
      date: null,
      birthday: false,
      Membershipdata:null,
      Package_type: [],
      package_:[],

      gender_:['male','female','non_binary'],
      schoolName:"",
      name: "",
      phone:"",
      club_number: "",
      gender: "",
      state: "",
      city: "",
      discription: "",
      address:{
        oneLineAddress:''
      },
      adminpassword: "",
      adminemail:"",
      zip:"",
      cancel_time:null,
      cancel_time_:['01:00:00','02:00:00','05:00:00','12:00:00','24:00:00'],
      commission:"",
      package_: [],
      memberShipID:[],

      passwordRule: [
        v => !!v || "Password is required",
        v => v.length >= 8 || "Password must be more than 8 characters"
      ],
      phoneRule: [
        v => !!v || "Phone Number is required",
        v => v.length <= 8 || "Minimum 8 Digits number"
      ],
      alert:{
        type:'',
        msg:''
      },
      loading:false,
      images:{
        image_for:'',
        temp_preview:[],
        profile_image:'',
        profile_image_preview:'',
        cover_image:'',
        cover_image_preview:'',
      },

    }),
    // beforeCreate(){
    // // },
    beforeDestroy(){
      // this.$store.state.ViweClubDetail=null
    },
    created(){
      let user=Store.state.user
      let self=this
      api.getData('admin/club').then(res=>{
        console.log(res)
        self.club.cvr=res.data.cvr_number
        self.club.schoolName=res.data.club_name
        self.club.phone=res.data.club_phone
        self.club.email=res.data.club_email
        self.address.street=res.data.street
        self.address.streetNumber=res.data.streetNumber
        self.address.floor=res.data.floor
        self.address.door=res.data.door
        self.address.zipCode=res.data.zipCode
        self.address.city=res.data.city
        self.zip=res.data.zipCode
        self.address.oneLineAddress =this.nullCheck(this.address.street)+this.nullCheck(this.address.streetNumber)+this.nullCheck(this.address.floor)+this.nullCheck(this.address.door)+this.nullCheck(this.address.zipCode)+this.nullCheck(this.address.city);
        self.images.profile_image_preview=res.data.user.image
        self.images.cover_image_preview=res.data.user.cover_image

      })
      console.log(user)
      this.admin.name=user.name
      this.admin.phone=user.phone
      this.admin.email=user.email
      this.admin.dob=user.dob
      this.admin.gender=user.gender
      // this.address=user.
      // this.address.street=user.street
      // this.address.streetNumber=user.streetNumber
      // this.address.floor=user.floor
      // this.address.door=user.door
      // this.address.zipCode=user.zipCode
      // this.address.city=user.city
      // this.zip=user.zip
      // this.address.oneLineAddress =this.nullCheck(this.address.street)+this.nullCheck(this.address.streetNumber)+this.nullCheck(this.address.floor)+this.nullCheck(this.address.door)+this.nullCheck(this.address.zipCode)+this.nullCheck(this.address.city);
      // console.log(this.address)
      // this.Membershipdata=this.$store.state.membership
      // // this.getclubData (this.id)
      // this.getpackage ()
      // this.pushToCustomer()
      // // this.getMembershipID(this.$store.state.ViweClubDetail.membership_id)

      // this.schoolName=this.$store.state.ViweClubDetail.name,
      // this.name=this.$store.state.ViweClubDetail.user.name,
      // this.date=this.$store.state.ViweClubDetail.user.dob,
      // this.phone=this.$store.state.ViweClubDetail.user.phone,
      // this.gender =this.$store.state.ViweClubDetail.user.gender,
      // this.state=this.$store.state.ViweClubDetail.user.state,
      // this.city=this.$store.state.ViweClubDetail.user.city,
      // this.discription=this.$store.state.ViweClubDetail.user.discription,
      // this.address=this.$store.state.ViweClubDetail.user.address,
      // this.adminemail=this.$store.state.ViweClubDetail.user.email,
      // this.zip=this.$store.state.ViweClubDetail.user.zip,
      // this.cancel_time=this.$store.state.ViweClubDetail.cancellation_time_period,
      // this.commission=this.$store.state.ViweClubDetail.commission
      // this.Package_type=this.getPackageName(this.$store.state.ViweClubDetail.membership_id)




    },
    methods: {
      onPickImage(image_for) {
        this.images.image_for=image_for
				this.$refs.imageInput.click();
			},
      OnImagePicked(event) {
        this.images.temp_preview=[]
       

				const files = event.target.files;
				let fileName = files[0].name;
				// this.club.club_logo = fileName;
        console.log(files[0])
				if (fileName.lastIndexOf(".") <= 0) {
					// return alert("Please add a valid file! ");
          return
				}else if(files[0].size>1500000){
          return alert("Size")
        }
			  const fileReader = new FileReader();
        let self=this
        fileReader.readAsDataURL(files[0]);
        fileReader.addEventListener("load", () => {
          self.images.temp_preview.push(fileReader.result)
          // console.log(fileReader.result)
        });
        setTimeout(()=>{
            console.log(self.images)
            if(self.images.image_for=='profile'){
              // debugger
              this.images.profile_image=[]
              
              self.images.profile_image=files[0]
              // self.images.profile_image_preview=self.images.temp_preview[0]
            }else if(self.images.image_for=='cover'){
              
              this.images.cover_image=[]
              self.images.cover_image=files[0]
              // self.images.cover_image_preview=self.images.temp_preview[0]
            }
            self.ChangeImage(this.image_for)
        },400);

				// this.club.club_logo = files[0];

				// this.club.club_logo_name = files[0].name;

			},
      ChangeImage(image_for){
        var url,Data
        Data=new FormData()
        if(this.images.image_for=='profile'){
          url="changeProfileImage"
          Data.append('image',this.images.profile_image)
        }else if(this.images.image_for=='cover'){
          url="changeCoverImage"
          Data.append('cover_image',this.images.cover_image)
        }
        let self=this
        api.postData(url,Data)
        .then(res=>{
          // debugger
          if(self.images.image_for=='profile'){
            self.images.profile_image_preview=''
            self.images.profile_image_preview=self.images.temp_preview[0]
          }else if(self.images.image_for=='cover'){
            self.images.cover_image_preview=''
            self.images.cover_image_preview=self.images.temp_preview[0]
          }

        })
        
      },
      updateProfile(){
        this.loading=true
        let club={
          cvr_number:this.club.cvr,
          club_name:this.club.schoolName,
          club_phone:this.club.phone,
          club_email:this.club.email,
          door:this.address.door,
          floor:this.address.floor,
          street:this.address.street,
          streetNumber:this.address.streetNumber,
          zipCode:this.address.zipCode,
          city:this.address.city
        }
        let admin={
          name:this.admin.name,
          phone:this.admin.phone,
          dob:this.admin.dob,
          gender:this.admin.gender,
          email:this.admin.email,
        }
        console.log(club)
        console.log(admin)
        api.postData('admin/profile',admin)
        .then(res=>{
              if(res.status==201){
                // this.loading=false
                // this.alert.type="success"
                // this.alert.msg="successfully updated"
                api.postData('admin/club',club)
                .then(res=>{
                      if(res.status==201){
                        this.loading=false
                        this.alert.type="success"
                        this.alert.msg="successfully updated"
                      }
                }).catch(err=>{
                      this.loading=false
                      this.alert.type="warning"
                      this.alert.msg="updation failed"
                })
              }
        }).catch(err=>{
              this.loading=false
              this.alert.type="warning"
              this.alert.msg="updation failed"
        })


      },
      nullCheck(value){
        if(value){
          return value+' ';
        }else{
          return ""
        }
      },
      selectItem(payload, objectName) {
        this.$set(this, objectName, this.translateData(payload));
        // this.newUser.user.address = this.translateData(payload);
      },
      translateData(address) {
        if (!address || !address.data) {
          return;
        }
        return {
          id: address.data.id,
          street: address.data.vejnavn,
          streetNumber: address.data.husnr,
          floor: address.data.etage,
          door: address.data.dør,
          zipCode: address.data.postnr,
          city: address.data.postnrnavn,
          oneLineAddress: address.tekst,
          village : address.Tversted
        };
      },
      pushToCustomer(){
        if (this.$store.state.ViweClubDetail==null){
          this.$router.push("../customers")
          this.$notify({
            group: "error",
            type: "error",
            text: "Error"
          });
        }

      },
      // getclubData(id){
      //         this.$store.dispatch('viewClub',id)
      //         .then(res=>{

      //         },error=>{
      //             this.$notify({
      //                 group: "error",
      //                 type: "error",
      //                 text: error
      //       });

      //         })
      //     },
      onSignup() {

        var admin_id = this.$store.state.ViweClubDetail.admin_id
        var club_id = this.$store.state.ViweClubDetail.id

        var adminData={
          name: this.name,
          email: this.adminemail,
          phone: this.phone,
          dob: this.date,
          address: this.address,
          city: this.city,
          state: this.state,
          zip: this.zip,
          gender: this.gender.toLowerCase(),
          // role: "admin",
        }
        this.getMembershipID()

        this.$store.dispatch('adminEdit',{adminData,admin_id})
          .then(response=>{
              var ClubData = {
                name:this.schoolName,
                admin_id:admin_id,
                cancellation_time_period:this.cancel_time,
                commission:this.commission,
                membership_id:this.memberShipID

              }

              this.$store.dispatch('clubEdit',{ClubData,club_id} )
                .then(clubRes=>{

                    this.$notify({
                      group: "success",
                      type: "success",
                      text: "Successfully updated"
                    });
                    this.$router.push("../customers")


                  },
                  error=>{

                    this.$notify({
                      group: "error",
                      type: "error",
                      text:error.message,
                    });


                  })

            },
            error=>{
              this.$notify({

                group: "error",
                type: "error",
                text:error.message,
              });

            })

      },
      getpackage (){
        this.$store.dispatch('getPackage').then(res=>{
          this.Membershipdata = res.data
          for(let key in this.Membershipdata){
            this.package_.push(this.Membershipdata[key].name )
          }
        },error=>{

        })
      },
      getMembershipID(){
        for (let i = 0; i < this.Package_type.length; i++) {
          for (let a = 0; a < this.Membershipdata.length; a++) {
            if (this.Package_type[i]==this.Membershipdata[a].name){
              this.memberShipID.push(this.Membershipdata[a].id)
            }
          }
        }
      },
      getPackageName(data){
        var packagename=[]
        for (let i = 0; i < data.length; i++) {
          for(let key in this.Membershipdata){

            if (data[i]== this.Membershipdata[key].id){
              packagename.push(this.Membershipdata[key].name)
            }
          }
        }
        return packagename
      },


    },
    computed:{
      // loading(){
        // return this.$store.getters.loading
      // }
    }

  };
</script>



// WEBPACK FOOTER //
// src/components/profile/admin/EditProfile.vue